import React from "react";
import {modalActions} from "../actions/modal.actions";
import {connect} from "react-redux";
import {claimTypes} from "../constants/claim.constants";
import {withNamespaces} from "react-i18next";

const DeviceContentInfoColumn = ({t, user, content, hideModal, showModal }) => {
    const networkDeviceContentCrud      = user[`c_network-device-content.actions.crud`] || null;

    const onClickLabel = (content, e) => {
        e.preventDefault();
        showModal({
            open: true,
            large: true,
            title: 'Device Content info',
            contentModel: content,
            closeModal: closeModal,
        }, 'deviceContentInfo')
    };

    const closeModal = () => {
        hideModal()
    };

    let isVersion = null;
    if(content.version) {
        isVersion = (
            <small>{ t('version').toLowerCase() + " " + content.version } </small>
        )
    }

    return (
        <h6>
            { (networkDeviceContentCrud === claimTypes.READ_WRITE || networkDeviceContentCrud === claimTypes.READ) ? (
                <span className="custom-link" onClick={(e) => onClickLabel(content, e)}>
                    <p className="m-0">{content.label}</p>
                    { isVersion }
                </span>
            ) : (
                <React.Fragment>
                    <p className="m-0">{ content.label }</p>
                    { isVersion }
                </React.Fragment>
            ) }
        </h6>
    )


};
const mapStateToProps = (state) => {
    const { user } = state.authenticationReducer;
    return {
        user
    }
};
const mapDispatchToProps = dispatch => ({
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({modalProps, modalType}))
    }
});
export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(DeviceContentInfoColumn));
